module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-001"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_VIII"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvVIII"
    }
  }, [_vm._v("PUBLISHER’S NOTE REGARDING"), _c('br'), _vm._v("THIS DIGITAL EDITION")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvVIII"
    }
  }, [_c('i', [_vm._v("Due to limitations regarding digital rights, the RSV Scripture text is linked to but does not appear in this digital edition of this Ancient Christian Commentary on Scripture volume as it does in the print edition. Page numbering has been maintained, however, to match the print edition. We apologize for any inconvenience this may cause.")])]), _c('i', [_c('a', {
    attrs: {
      "id": "page_IX"
    }
  }), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvIX"
    }
  })])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 66
// module chunks = 0